module.exports = __webpack_public_path__ + "static/media/mercedes-7.414431f9.jpg";